export enum LOG_UPLOAD_STATE {
  NONE = 'NONE',
  REQUESTED = 'REQUESTED',
  ERROR = 'ERROR',
  PROGRESS = 'PROGRESS',
  SUCCESS = 'SUCCESS'
}